define('collection/MenuCollection',['require','lib/collection/BaseCollection','model/MenuModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var MenuModel = require('model/MenuModel');

    /**
     * Menu collection
     *
     * @class MenuCollection
     */
    return BaseCollection.extend({
        url: '/menu/list/',
        model: MenuModel,

/*        _getPageModel : function (id) {
            var model =  this.get(id);

            if (!model) {
                model = new StaticPageModel({id : id});
                model.fetch();
                this.add(model);
            }

            return model;
        }*/
    });

});
